import { Stack } from "@mantine/core"
import { useForm } from "@mantine/form"
import { ErrorBox } from "@tfg/ui"
import type { AxiosError } from "axios"
import { zod4Resolver } from "mantine-form-zod-resolver"
import { useTranslation } from "react-i18next"
import { z } from "zod"

import { standardEmail } from "@tfg/types/schemas/utils"

import { LoginButton } from "./LoginButton"
import { LoginTextInput } from "./LoginTextInput"

const usernameSchema = z.object({
  username: standardEmail(),
})

type UsernameFormProps = {
  onSubmit: (values: z.infer<typeof usernameSchema>) => Promise<void>
  isLoading: boolean
  error: Error | AxiosError<unknown, unknown> | null
  errorTitle?: string
}

export const UsernameForm = ({
  onSubmit,
  isLoading,
  error,
  errorTitle,
}: UsernameFormProps) => {
  const { t } = useTranslation("account")
  const form = useForm<z.infer<typeof usernameSchema>>({
    validate: zod4Resolver(usernameSchema),
    initialValues: {
      username: "",
    },
  })

  return (
    <>
      <ErrorBox title={errorTitle} error={error} />
      <Stack align="right" gap="xl" w="100%">
        <LoginTextInput
          name="username"
          type="email"
          autoComplete="username"
          required
          autoFocus
          label={t("login.labels.email")}
          placeholder={t("login.placeholders.email")}
          onSubmit={() => form.onSubmit(onSubmit)()}
          {...form.getInputProps("username")}
          data-testid="login-email"
        />
        <LoginButton
          loading={isLoading}
          data-testid="login-next"
          onClick={() => form.onSubmit(onSubmit)()}
        >
          {t("login.usernameSubmit")}
        </LoginButton>
      </Stack>
    </>
  )
}
